module.exports = __webpack_public_path__ + "static/images/e72d1907bf5d0f6c1153e50aa7cf7f9a.png";